import { Chip, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { isAdminRole, isAgencyRole } from '../../../../helpers/roles';

const AdvertiserChip = styled(Chip)({
  color: '#2E2C34',
  fontWeight: 600,
  maxHeight: 29,
});

const Advertiser = ({ userRole = {}, advertiser }) => {
  if (isAdminRole(userRole.value) || isAgencyRole(userRole.value)) {
    return <div className='pl-5'>&mdash;</div>;
  }

  if (!advertiser) return null;

  return <AdvertiserChip variant='outlined' label={advertiser.name} />;
};

Advertiser.propTypes = {
  userRole: PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  advertiser: PropTypes.shape({ name: PropTypes.string }),
};

export default Advertiser;
